import { useMemo } from 'react';
import { Text, Stack, makeStyles } from '@fluentui/react';
import { useMobileContext } from '../../../../MobileContext';
import { useMobile } from '../../../../useMobile';
import { mobileConstants } from '../../../../mobileConstants';
import { formatNumberToDisplay, formatNumberToDisplayPercent } from '../../../../mobileUtils';
import { useConfigValuesState } from '../../../../../hooks/useConfigValue';

export const TotalRow = () => {
    const mobCtx = useMobileContext();
    const classes = getStyles();

    const totalValue = useMobile(state => state.totalValues?.all);

    const {
        initialData: {
            configuration: { timeEntryRoundingInterval, gridInputType, capacityDefault },
            aggregatedUser: { user },
        },
    } = useConfigValuesState();

    const userCapacity = useMemo(() => user.availability ?? user.calendar?.dailyCapacity ?? capacityDefault, [user, capacityDefault]);

    const value = useMemo(() => {
        if (!totalValue || Number.isNaN(Number(totalValue))) return '';

        if (mobCtx.showAsPercent) {
            return formatNumberToDisplayPercent(totalValue, mobCtx.selectedPeriodDays, userCapacity, timeEntryRoundingInterval);
        } else {
            return formatNumberToDisplay(totalValue, timeEntryRoundingInterval);
        }
    }, [totalValue, mobCtx.selectedPeriodDays, gridInputType]);

    return (
        <Stack horizontal verticalAlign="center" className={classes.root}>
            <Stack grow verticalAlign="center">
                <Text className={classes.txt}>Total {`${mobCtx.showAsPercent && value ? '%' : 'hours'}`}</Text>
            </Stack>
            <Text className={classes.value}>
                {`${value}${mobCtx.showAsPercent && value ? ' %' : ''}`}
                {/* { totalValue || "" } */}
            </Text>
        </Stack>
    );
};

const getStyles = makeStyles(theme => ({
    root: [
        'totalRow',
        {
            height: mobileConstants.gridRowHeight,
            position: 'sticky',
            top: 0,
            backgroundColor: theme.semanticColors.bodyFrameBackground,
            zIndex: 60,
            borderBottom: `1px solid ${theme.semanticColors.bodyDivider}`,
            paddingLeft: 26,
            paddingRight: 16,
        },
    ],
    txt: {
        fontSize: 16,
        fontWeight: 600,
    },
    value: {
        fontSize: 16,
        fontWeight: 600,
    },
}));
